import CheckoutCallback from '@Organism/CheckoutCallback'
import React from 'react'

export default function DokuCallbackPage() {
  return (
    <CheckoutCallback/>
  )
}
